import {
  STREETS_SMART_API_LOADED,
  CYCLORAMA_LOADING,
} from '../actionTypes/CycloramaActionTypes'

export const streetsSmartApiLoaded = value => ({
  type: STREETS_SMART_API_LOADED,
  value,
})
export const cycloramaLoading = value => ({ type: CYCLORAMA_LOADING, value })



// WEBPACK FOOTER //
// ./src/store/Actions/CycloramaActions.js